<style scoped>
.wrapper {
	padding: 24px;
}
.row {
	margin-left: 0px;
}
.flex-box {
	-ms-flex-align: center;
	-webkit-align-items: center;
	-webkit-box-align: center;
	align-items: center;
}
.height-252 {
	height: 252px;
}
.height-260 {
	height: 260px;
}

.logo-panel {
	text-align: center;
}

.logo-item {
	margin-left: 24px;
	margin-right: 24px;
	margin-bottom: 24px;
	max-height: 50px;
}

@media screen and (max-width: 944px) {
	.logo-panel {
		display: none;
	}
}
</style>

<template>
	<div class="full-height display-flex display-flex-column">
		<div class="flex-box display-flex flex-item full-width">
			<mu-row class="full-width" gutter>
				<mu-col span="1" class="mobile-hide" />
				<mu-col span="12" sm="12" md="12" lg="5" xl="5" class="height-260">
					<div class="full-height display-flex display-flex-column">
						<div class="flex-item" />
						<Empty :condition="true" message="" />
						<div class="flex-item" />
					</div>
				</mu-col>
				<mu-col span="1" class="mobile-hide" />
				<mu-col span="2" class="mobile-show" />
				<mu-col span="12" sm="8" md="8" lg="4" xl="4" class="flex-box">
					<mu-paper :z-depth="1" class="full-width height-260">
						<mu-form :model="form" label-width="100" class="wrapper">
							<mu-form-item prop="input" :label="$t('login.username')">
								<mu-text-field v-model="modelUsername"></mu-text-field>
							</mu-form-item>
							<mu-form-item prop="input" :label="$t('login.password')">
								<mu-text-field v-model="modelPassword" :action-icon="visibility ? 'visibility_off' : 'visibility'" :action-click="() => (visibility = !visibility)" :type="visibility ? 'text' : 'password'"></mu-text-field>
							</mu-form-item>
							<mu-flex class="flex-wrapper" justify-content="center">
								<mu-button color="primary" type="submit" @click.prevent="onActionLogin" :disabled="isUsernameEmpty || isPasswordEmpty" v-loading="loading">
									{{ $t("login.guest") }}
								</mu-button>
								<mu-button @click.prevent="onClickHKULogin" color="secondary">
									{{ $t("login.sso") }}
								</mu-button>
							</mu-flex>
						</mu-form>
					</mu-paper>
				</mu-col>
				<mu-col span="1" class="mobile-hide" />
			</mu-row>
		</div>
		<div class="logo-panel">
			<img :src="hkuLogo" class="logo-item" />
			<img :src="teliLogo" class="logo-item" />
		</div>
	</div>
</template>

<script>
// Library
import axios from "axios";

// Components
import Empty from "@/components/Empty.vue";

export default {
	name: "LoginPage",
	components: {
		Empty,
	},
	data() {
		return {
			// Model
			modelUsername: "", // Bind with username input
			modelPassword: "", // Bind with password input
			type: "guest", // Bind with type input
			form: {},
			visibility: false,
			loading: false,
		};
	},
	watch: {},
	computed: {
		// Flag
		isUsernameEmpty() {
			return this.modelUsername === "";
		},
		isPasswordEmpty() {
			return this.modelPassword === "";
		},
	},
	created() {
		if (!this.$store.getters.previewMode) this.$store.commit("previewMode");
	},
	methods: {
		// Event
		onActionLogin() {
			this.loading = true;
			axios
				.post(
					this.$store.getters.urlApi + "auth",
					{
						username: this.modelUsername,
						password: this.modelPassword,
						type: this.type,
					},
					{
						headers: {
							token: this.$store.state.auth.token,
							"content-type": "application/json",
						},
					}
				)
				.then((response) => {
					this.token = response.data.data.token;
					this.$store.commit("login", {
						token: response.data.data.token,
						user: response.data.data.user,
						path: this.$route.path,
					});
					this.loading = false;
				})
				.catch((err) => {
					this.loading = false;
					this.$toast.error(err.response.data.message);
				});
		},
		onClickHKULogin() {
			window.location.href = this.$store.getters.urlApi + "auth/cas?redirect=" + this.$route.path;
		},
	},
};
</script>
